<script setup>
import { useSettingsStore } from "@/stores/storeSettings";
import PromoCodeBlock from "@/components/blocks/PromoCodeBlock.vue";

const storeSettings = useSettingsStore();
</script>

<template>
	<PromoCodeBlock v-if="storeSettings.activeEvent" />
</template>
